import { useRef } from 'react';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function UpdateWall() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = dir === 'left' ? -340 : 340;
    scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
  };

  const latestComics = [...comics]
    .sort((a, b) => b.latestChapter - a.latestChapter)
    .slice(0, 10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                最新更新
              </h2>
              <span className="text-xl md:text-2xl">🔥</span>
            </div>
            <p className="text-sm text-foreground-500 mt-1">24 小时热门连载抢先放送</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden md:inline px-3 py-1 rounded-full bg-foreground-900 text-background-50 text-xs font-medium whitespace-nowrap">
              实时榜单
            </span>
            <div className="flex items-center gap-1">
              <button
                onClick={() => scroll('left')}
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50 hover:bg-background-200 flex items-center justify-center cursor-pointer transition-colors"
                aria-label="向左滚动"
              >
                <i className="ri-arrow-left-s-line text-foreground-700"></i>
              </button>
              <button
                onClick={() => scroll('right')}
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50 hover:bg-background-200 flex items-center justify-center cursor-pointer transition-colors"
                aria-label="向右滚动"
              >
                <i className="ri-arrow-right-s-line text-foreground-700"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollSnapType: 'x mandatory' }}
        >
          {latestComics.map((comic, index) => (
            <div key={comic.id} className="flex-shrink-0 w-[160px] md:w-[200px]" style={{ scrollSnapAlign: 'start' }}>
              <ComicCard
                id={comic.id}
                slug={comic.slug}
                title={comic.title}
                coverImage={comic.coverImage}
                rating={comic.rating}
                latestChapter={comic.latestChapter}
                status={comic.status}
              />
            </div>
          ))}
          <div className="flex-shrink-0 w-[80px] md:w-[120px] flex items-center justify-center">
            <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-more-line text-foreground-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}